import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }         from '@ngx-translate/core';

import { CodeTypeModel }           from '../../core/models/code-type';
import { CompanyMessagesModel }    from '../../companies/models/company.messages';
import { CustomerModel }           from '../../customers/models/customer';
import { MessagesService }         from '../../messages/messages.service';
import { MessengerService }        from '../../messages/messenger/messenger.service';
import { JobsService }             from './transaction-center.jobs.service';
import { Table }                   from '../../table/types/table';
import { TemplatedWordingService } from '../../templates/templated-wording.service';
import { TemplateModel }           from '../../templates/typings/template';
import { ValidationsService }      from '../../sessions/validations.service';

@Component({
  selector   : 'wor-send-job-bulk-sms',
  template: require('./transaction-center.jobs.send-bulk-sms.component.html')
})
export class SendJobBulkSmsComponent implements OnInit {
  @BlockUI('bulkSmsFrontBlock') frontBlock: NgBlockUI;

  @Input() constraints    : Array<CodeTypeModel>;
  @Input() messageSettings: CompanyMessagesModel;
  @Input() statusTypes    : Array<CodeTypeModel>;

  allSelected  = false;
  customers    : Array<CustomerModel> = [];
  flipped      = false;
  selectedItems: Array<CustomerModel> = [];
  smsLength    = 160;
  smsMessage   = '';
  tableSettings: Table = {};

  filters = {
    endDate    : null,
    invoiceType: '*',
    jobStatus  : '*',
    startDate  : null
  };

  constructor (
    public  activeModal             : NgbActiveModal,
    private jobsService             : JobsService,
    private messagesService         : MessagesService,
    private messengerService        : MessengerService,
    private templatedWordingService : TemplatedWordingService,
    private translateService        : TranslateService,
    private validationsService      : ValidationsService
  ) {}

  ngOnInit () : void {
    this.smsMessage = this.messageSettings?.default_bulk_sms_message || '';
  }

  addTemplates () : void {
    this.templatedWordingService.addTemplate('sms')
    .then(( templates : Array<TemplateModel> ) => {
      templates.forEach(template => {
        this.smsMessage = this.smsMessage
          ? `${ this.smsMessage }\n\n${ template.wording }`
          : String(template.wording);
      });
    });
  }

  buildTableSettings () : Table {
    return {
      columns: [
        {
          field : 'display_name',
          header: {
            text: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER')
          }
        },
        {
          field : 'mobile',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.MOBILE')
          }
        },
        {
          field : 'job_card_number',
          header: {
            text: this.translateService.instant('INVOICE_SPACE.JOB_CARD_NUMBER')
          }
        },
        {
          field : 'job_status_comment',
          header: {
            text: this.translateService.instant('INVOICE_SPACE.JOB_STATUS_COMMENT')
          }
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true,
          multi  : true
        }
      },
      sorting: {
        enabled: false
      },
      static: true
    };
  }

  onRowClick () : void {
    this.selectedItems = this.customers.filter(customer => customer.selected);

    this.allSelected = !!this.customers.length
      && this.selectedItems.length === this.customers.length;
  }

  search () : void {
    this.frontBlock.start();

    this.jobsService.getBulkSmsCustomers(this.filters)
    .then(( customers : Array<CustomerModel> = [] ) => {
      this.customers = customers;

      if ( !this.customers.length ) {
        this.messagesService.show(this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND'), 'error');

        this.activeModal.close();

        return;
      }

      this.tableSettings  = this.buildTableSettings();
      this.selectedItems  = [];
      this.allSelected    = false;
      this.flipped        = true;
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.frontBlock.stop());
  }

  selectAll () : void {
    this.allSelected = !this.allSelected;

    this.customers.forEach(customer => customer.selected = this.allSelected);

    this.selectedItems = this.customers.filter(customer => customer.selected);
  }

  sendSms () : void {
    const customers : Array<any> = this.selectedItems.map(( customer : any ) => {
      const firstName = customer.customer_type === 'C'
        ? ( customer.contact_first || customer.contact1_first || customer.contact2_first || customer.company_name )
        : customer.first_name;

      return {
          customer_id: customer.customer_id,
          first_name : firstName,
          name       : customer.display_name,
          phone      : customer.mobile,
          valid      : this.validationsService.isPhoneNumberValid(customer.mobile, true) ? 'yes' : 'no'
        };
    });

    this.messengerService.sendBulkSms(customers, this.smsMessage)
    .then(() => {
      this.messagesService.show(this.translateService.instant('GENERAL_SPACE.MESSAGE.BULK_SMS_SENT'), 'success');

      this.activeModal.close();
    })
    .catch(error => this.messagesService.error(error));
  }
}
